import {
  CHANGE_STU_STATUS,
  SET_STUDENT,
  SET_STUDENTS,
  TOGGLE_NAVBAR,
} from '../constants/';

const studentDefaultState = {
  data: [],
  navbarToggle: false,
};

const studentReducer = (state = studentDefaultState, action) => {
  switch (action.type) {
    case SET_STUDENTS:
      return action.payload;
    case SET_STUDENT:
      return action.payload;
    case CHANGE_STU_STATUS:
      return { ...state, student_status: action.payload.status };
    case TOGGLE_NAVBAR:
      return { ...state, navbarToggle: action.payload };
    default:
      return state;
  }
};
export default studentReducer;
